import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import BridgeStripeGate from "./BridgeStripeGate";
import BridgeStripeTransferPanel from "./BridgeStripeTransferPanel";

export default function BridgeStripeDevPage() {
  const [readyCustomer, setReadyCustomer] = useState(null);

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto", p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 900, mb: 2 }}>
        BridgeStripe Integration Test
      </Typography>

      <Stack spacing={2.5}>
        <BridgeStripeGate onReady={(c) => setReadyCustomer(c)} />

        {/* Only show transfer testing when ready */}
        {readyCustomer ? (
          <BridgeStripeTransferPanel defaultMetadata={{ projectId: "test id" }} />
        ) : null}
      </Stack>
    </Box>
  );
}
